module.exports = __webpack_public_path__ + "static/media/DT.bf2fecc2.png";